import { useState } from 'react';

const faqs = [
  {
    q: '香蕉动漫是完全免费的吗？需要注册吗？',
    a: '是的，香蕉动漫所有漫画资源永久免费，无需注册、无需登录即可畅读全部内容。我们致力于为每一位漫画爱好者提供零门槛的阅读体验。',
  },
  {
    q: '平台支持哪些漫画类型？',
    a: '香蕉动漫收录了韩漫、日漫、国漫、条漫等多种类型，涵盖热血、恋爱、悬疑、奇幻、古风、都市、搞笑、异世界、治愈等丰富题材，总资源量超过三万部。',
  },
  {
    q: '漫画更新频率如何？',
    a: '热门连载漫画每日同步更新，我们与多家内容方保持紧密合作，确保读者第一时间追更最新话。一般工作日更新频率更高，节假日也会有精选推荐。',
  },
  {
    q: '移动端阅读体验怎么样？',
    a: '香蕉动漫专为移动端优化了下拉式阅读模式，自动适配手机和平板屏幕，加载速度快，翻页流畅无卡顿。无论是在通勤路上还是睡前时光，都能享受沉浸式阅读。',
  },
  {
    q: '如何推荐漫画或反馈问题？',
    a: '欢迎通过页面上的"联系我们"区域提交漫画推荐、内容建议或使用问题。你的每一条反馈我们都认真对待，帮助香蕉动漫变得更好。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-question-line"></i>
            问答
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">常见问题</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            关于香蕉动漫你可能想了解的一切，快速解答你的疑问
          </p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden cursor-pointer"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 md:p-6 text-left"
                onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
              >
                <h3 className="font-heading text-base md:text-lg text-foreground-900 pr-4">{faq.q}</h3>
                <i
                  className={`ri-arrow-down-s-line text-xl text-foreground-400 transition-transform duration-300 shrink-0 ${
                    openIndex === i ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 md:px-6 pb-5 md:pb-6 text-sm md:text-base text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}